"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const react_1 = __importDefault(require("react"));
const FlagButton_1 = __importDefault(require("./FlagButton"));
const useStyles = (0, makeStyles_1.default)(() => ({
    flags: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
    },
}));
function LanguageSelector() {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.flags },
        react_1.default.createElement(FlagButton_1.default, { country: "FI", lng: "fi" }),
        react_1.default.createElement(FlagButton_1.default, { country: "SE", lng: "sv" })));
}
exports.default = LanguageSelector;
